import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';

interface HeaderProps {
  title?: string;
  subtitle?: string;
}

export const Header: React.FC<HeaderProps> = ({ 
  title = "SIIS Immigration Services",
  subtitle = "Professional Immigration Consultation"
}) => {
  const handleLogoClick = () => {
    window.location.href = 'https://www.siis.ca/';
  };


  return (
    <header className="bg-white border-b border-gray-200">
      <div className="container mx-auto px-4 sm:px-6 py-4 sm:py-6">
        <div className="flex items-center justify-between gap-4">
          {/* Logo and Title */}
          <div className="flex items-center gap-2 sm:gap-4 min-w-0 flex-1">
            <div className="flex items-center gap-2 sm:gap-3 min-w-0">
              {/* SIIS Logo - Clickable */}
              <div 
                className="cursor-pointer"
                onClick={handleLogoClick}
              >
                <Logo size="md" />
              </div>
              {/* Title and Subtitle - Not clickable */}
            </div>
          </div>

        </div>
      </div>
    </header>
  );
};
